/**
 * 日志管理 API
 * 对应 foundation-service (7092)
 */

import { unifiedApi } from '@/utils/unifiedApi';
import handleApiResponse from '@/utils/apiResponseHandler';
import type {
  LoginLogInfo,
  LoginLogQueryParams,
  LoginStatisticsResp,
  AuditLogInfo,
  AuditLogQueryParams,
  AuditStatisticsResp,
} from './types';

const service = () => unifiedApi.service('foundation');

// ==================== 登录日志 API ====================

/** 获取登录日志列表 */
export const getLoginLogList = async (params?: LoginLogQueryParams) => {
  return handleApiResponse(
    service().get<{ list: LoginLogInfo[]; total: number }>('/login-logs', { params })
  );
};

/** 获取登录统计 */
export const getLoginStatistics = async (params?: { tenant_id?: number; start_time?: string; end_time?: string }) => {
  return handleApiResponse(
    service().get<LoginStatisticsResp>('/login-logs/statistics', { params })
  );
};

/** 获取用户登录历史 */
export const getUserLoginHistory = async (userId: number, limit?: number) => {
  return handleApiResponse(
    service().get<{ list: LoginLogInfo[] }>(`/login-logs/users/${userId}/history`, {
      params: { limit },
    })
  );
};

/** 导出登录日志 */
export const exportLoginLogs = async (params?: LoginLogQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });
  }

  const response = await service().get('/login-logs/export', {
    params,
    responseType: 'blob',
  });
  return response;
};

/** 登录日志 API 对象 */
export const loginLogApi = {
  getList: getLoginLogList,
  getStatistics: getLoginStatistics,
  getUserHistory: getUserLoginHistory,
  export: exportLoginLogs,
};

// ==================== 审计日志 API ====================

/** 获取审计日志列表 */
export const getAuditLogList = async (params?: AuditLogQueryParams) => {
  return handleApiResponse(
    service().get<{ list: AuditLogInfo[]; total: number }>('/audit-logs', { params })
  );
};

/** 获取审计统计 */
export const getAuditStatistics = async (params?: { tenant_id?: number; start_time?: string; end_time?: string }) => {
  return handleApiResponse(
    service().get<AuditStatisticsResp>('/audit-logs/statistics', { params })
  );
};

/** 导出审计日志 */
export const exportAuditLogs = async (params?: AuditLogQueryParams) => {
  const response = await service().get('/audit-logs/export', {
    params,
    responseType: 'blob',
  });
  return response;
};

/** 审计日志 API 对象 */
export const auditLogApi = {
  getList: getAuditLogList,
  getStatistics: getAuditStatistics,
  export: exportAuditLogs,
};

export default {
  loginLog: loginLogApi,
  auditLog: auditLogApi,
};
